import React from 'react';
import classNames from 'classnames';
import { TabsProps } from './type/props';
import { FieldWrapper } from '../../molecules/FieldWrapper/FieldWrapper';
import * as styles from './tabs.module.sass';
import { Button } from '../../atoms/button';

export const Tabs = (props: TabsProps) => {
  const tabLabels = [];

  for (const [key, item] of Object.entries(props.tabs)) {
    {
      item.title &&
        tabLabels.push(
          <Button
            className={styles.choose_button}
            text={item.title}
            key={key}
            textClassName={classNames({ [styles.active]: props.activeTab === key })}
            onClick={() => props.onChooseHandler(key)}
          />,
        );
    }
  }

  return (
    <FieldWrapper>
      <div className={styles.tabs_container}>{tabLabels}</div>
      <div>{props.tabs[props.activeTab].content}</div>
    </FieldWrapper>
  );
};
